const layout = {
    minHeight: "100vh",
};
const content = {
    position: "relative",
    height: "100%",
};
const header = {
    height: "48px",
    lineHeight: "46px",
    padding: 0,
    // background: "#001529",
    background: "white",
};
const footer = {
    textAlign: "center",
    background: "rgba(0,0,0,.05)",
};
export const theme = { layout, content, header, footer };
//# sourceMappingURL=theme.js.map